<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      po_id: null,
      po_number: '',
      advance_amount_pct: null,
      payment_duration_days: null,
      balance: {
        taxable_amount: 0,
        tax_amount: 0,
        total_received_value: 0,
        advance_amount: 0,
        total_paid: 0,
        balance_due: 0
      },
      payments: [],
      amount_paid: null,
      payment_date: '',
      payment_mode: null,
      reference_number: '',
      remarks: '',
      document: null,
      errors: {},
      paymentModes: ['Cash', 'UPI', 'Bank Transfer', 'Cheque', 'NEFT/RTGS'],
      module_url: 'inventory/purchase-orders',
    };
  },

  methods: {
        async open(row) {
        this.resetForm();               
        this.po_id = row.id;            
        this.po_number = row.po_number;
        this.advance_amount_pct = row.advance_amount_pct ?? null;
        this.payment_duration_days = row.payment_duration_days ?? null;
        await this.fetchPayments();
        this.$nextTick(() => {
            this.$openModal('purchase_order_payment_modal');
        });
        },

    async fetchPayments() {
      this.setLoading(true);
      try {
        const response = await axios.get(`/${this.module_url}/${this.po_id}/payments`);
        const data = response.data.data;
        this.balance = data.balance;
        this.payments = data.payments || [];
        this.amount_paid = this.balance.balance_due > 0 ? this.balance.balance_due : null;
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async addPayment() {
      this.errors = {};
      this.setLoading(true);
      try {
        const formData = new FormData();
        formData.append('amount_paid', this.amount_paid);
        formData.append('payment_date', this.payment_date);
        formData.append('payment_mode', this.payment_mode);
        formData.append('reference_number', this.reference_number || '');
        formData.append('remarks', this.remarks || '');
        if (this.document) {
          formData.append('document', this.document);
        }
        const response = await axios.post(`/${this.module_url}/${this.po_id}/payments`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        this.$swalToast(
            typeof response.data.message === 'string' ? response.data.message : 'Payment added successfully',
            'success'
            );
        this.resetFormFields();
        await this.fetchPayments();
        this.$emit('updated');
      } catch (error) {
        if (error?.type === 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
      }
    },

    async deletePayment(paymentId) {
      const result = await this.$confirm({
        title: 'Delete Payment?',
        text: 'This action cannot be undone.'
      });
      if (!result.isConfirmed) return;

      this.setLoading(true);
      try {
        await axios.delete(`/${this.module_url}/${this.po_id}/payments/${paymentId}`);
        this.$swalToast('Payment deleted successfully', 'success');
        await this.fetchPayments();
        this.$emit('updated');
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

    resetFormFields() {
      this.payment_date = '';
      this.payment_mode = null;
      this.reference_number = '';
      this.remarks = '';
      this.document = null;
      if (this.$refs.documentInput) {
        this.$refs.documentInput.value = '';
      }
      this.errors = {};
    },
    resetForm() {
      this.po_id = null;
      this.po_number = '';
      this.advance_amount_pct = null;
      this.payment_duration_days = null;
      this.balance = {
        taxable_amount: 0,
        tax_amount: 0,
        total_received_value: 0,
        advance_amount: 0,
        total_paid: 0,
        balance_due: 0
      };
      this.payments = [];
      this.resetFormFields();
    }
  }
};
</script>

<style scoped>
.pm-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 10px; padding: 12px 14px; text-align: center;
}
.pm-card-label { font-size: 10px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: .4px; margin-bottom: 4px; }
.pm-card-val { font-size: 15px; font-weight: 800; color: #0f172a; }
.pm-label { font-size: 11px; font-weight: 600; color: #475569; margin-bottom: 4px; display: block; }
.pm-input, .pm-select { width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px; height: 36px; padding: 0 11px; font-size: 12.5px; outline: none; }
.pm-err { font-size: 10.5px; color: #f43f5e; margin-top: 3px; }
.pm-table th { font-size: 11px; font-weight: 700; color: #475569; background: #f8fafc; padding: 8px 10px; text-transform: uppercase; }
.pm-table td { font-size: 12.5px; color: #1e293b; padding: 8px 10px; vertical-align: middle; }

.pm-terms-bar {
  display: flex; align-items: center; gap: 20px; flex-wrap: wrap;
  background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px;
  padding: 10px 16px; margin-bottom: 14px;
}
.pm-terms-item { display: flex; align-items: center; gap: 8px; }
.pm-terms-icon {
  width: 28px; height: 28px; border-radius: 7px; background: #dbeafe;
  display: flex; align-items: center; justify-content: center; color: #2563eb; font-size: 13px; flex-shrink: 0;
}
.pm-terms-label { font-size: 10px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: .3px; }
.pm-terms-val { font-size: 13px; font-weight: 700; color: #0f172a; }
</style>

<template>
<div class="modal fade" id="purchase_order_payment_modal" tabindex="-1">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" style="border:none; border-radius:16px; overflow:hidden;">

      <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f); border:none; padding:15px 20px;">
        <div>
          <h5 class="modal-title" style="color:#fff; font-weight:700; font-size:14px; margin:0;">
            {{ po_number }} — Manage Payment
          </h5>
          <div style="font-size:11px; color:#94a3b8; margin-top:2px;">View balance and record payments</div>
        </div>
        <button class="btn-close btn-close-white" data-bs-dismiss="modal" style="opacity:.7;"></button>
      </div>

      <div class="modal-body" style="padding:20px; background:#f8fafc;">

        <!-- PO Terms: Advance % & Payment Duration -->
        <div class="pm-terms-bar" v-if="advance_amount_pct !== null || payment_duration_days !== null">
          <div class="pm-terms-item" v-if="advance_amount_pct !== null">
            <div class="pm-terms-icon"><i class="ti ti-percentage"></i></div>
            <div>
              <div class="pm-terms-label">Advance Amount %</div>
              <div class="pm-terms-val">{{ advance_amount_pct }}%</div>
            </div>
          </div>
          <div class="pm-terms-item" v-if="payment_duration_days !== null">
            <div class="pm-terms-icon"><i class="ti ti-calendar-time"></i></div>
            <div>
              <div class="pm-terms-label">Payment Duration</div>
              <div class="pm-terms-val">{{ payment_duration_days }} Days</div>
            </div>
          </div>
        </div>

        <!-- Balance Summary -->
        <div class="row g-2 mb-4">
          <div class="col-md-2 col-6">
            <div class="pm-card">
              <div class="pm-card-label">{{ balance.tax_amount > 0 ? 'Taxable Amt' : 'Amount' }}</div>
              <div class="pm-card-val">{{ balance.taxable_amount }}</div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="pm-card">
              <div class="pm-card-label">Tax Amt</div>
              <div class="pm-card-val">{{ balance.tax_amount }}</div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="pm-card">
              <div class="pm-card-label">Total Value</div>
              <div class="pm-card-val">{{ balance.total_received_value }}</div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="pm-card">
              <div class="pm-card-label">Advance</div>
              <div class="pm-card-val" style="color:#2563eb;">{{ balance.advance_amount }}</div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="pm-card">
              <div class="pm-card-label">Total Paid</div>
              <div class="pm-card-val" style="color:#16a34a;">{{ balance.total_paid }}</div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="pm-card" style="background:#fff0f3; border-color:#fecdd3;">
              <div class="pm-card-label">Balance Due</div>
              <div class="pm-card-val" style="color:#f43f5e;">{{ balance.balance_due }}</div>
            </div>
          </div>
        </div>

        <!-- Add Payment Form -->
         <div v-if="balance.balance_due > 0" style="background:#fff; border:1px solid #e2e8f0; border-radius:10px; padding:16px; margin-bottom:20px;">
          <div style="font-size:12px; font-weight:700; color:#0f172a; margin-bottom:12px;">
            <i class="ti ti-plus-circle me-1"></i>Add Payment
          </div>
          <div class="row g-3">
            <div class="col-md-3">
              <label class="pm-label">Amount Paid <span style="color:#f43f5e;">*</span></label>
              <input type="number" class="pm-input" v-model.number="amount_paid" placeholder="0.00" />
              <div v-if="errors.amount_paid" class="pm-err">{{ errors.amount_paid[0] }}</div>
            </div>
            <div class="col-md-3">
              <label class="pm-label">Payment Date <span style="color:#f43f5e;">*</span></label>
              <input type="date" class="pm-input" v-model="payment_date" />
              <div v-if="errors.payment_date" class="pm-err">{{ errors.payment_date[0] }}</div>
            </div>
            <div class="col-md-3">
              <label class="pm-label">Payment Mode <span style="color:#f43f5e;">*</span></label>
              <vue-select :options="paymentModes" v-model="payment_mode" placeholder="Select mode" />
              <div v-if="errors.payment_mode" class="pm-err">{{ errors.payment_mode[0] }}</div>
            </div>
            <div class="col-md-3">
              <label class="pm-label">Reference Number</label>
              <input type="text" class="pm-input" v-model="reference_number" placeholder="TRXN0001" />
              <div v-if="errors.reference_number" class="pm-err">{{ errors.reference_number[0] }}</div>
            </div> 
            <div class="col-md-3">
              <label class="pm-label">Document <span style="color:#f43f5e;">*</span></label>
              <input type="file" class="pm-input" ref="documentInput"
                @change="document = $event.target.files[0]" style="padding:6px 8px;" />
              <div v-if="errors.document" class="pm-err">{{ errors.document[0] }}</div>
            </div>
            
            <div class="col-md-9">
              <label class="pm-label">Remarks</label>
              <input type="text" class="pm-input" v-model="remarks" placeholder="Payment remarks..." />
              <div v-if="errors.remarks" class="pm-err">{{ errors.remarks[0] }}</div>
            </div>
            <div class="col-md-3 d-flex align-items-end">
              <button type="button" class="btn btn-primary w-100" @click="addPayment">
                <i class="ti ti-device-floppy me-1"></i>Add Payment
              </button>
            </div>
          </div>
        </div>
        <div v-else style="background:#f0fdf4; border:1px solid #bbf7d0; border-radius:10px; padding:20px; margin-bottom:20px; text-align:center;">
          <i class="ti ti-circle-check" style="font-size:22px; color:#16a34a;"></i>
          <div style="font-size:13px; font-weight:700; color:#16a34a; margin-top:6px;">
            Your due is clear
          </div>
          <div style="font-size:11.5px; color:#64748b; margin-top:2px;">
            All payments have been received for this purchase order.
          </div>
        </div>

        <!-- Payments Table -->
        <div style="background:#fff; border:1px solid #e2e8f0; border-radius:10px; overflow:hidden;">
          <table class="table mb-0 pm-table">
            <thead>
              <tr>
                <th>Amount</th>
                <th>Date</th>
                <th>Mode</th>
                <th>Reference No</th>
                <th>Remarks</th>
                <th>Created By</th>
                <!-- <th>Action</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in payments" :key="payment.id">
                <td style="font-weight:700; color:#16a34a;">{{ payment.amount_paid }}</td>
                <td>{{ $formatDate(payment.payment_date, 'DD-MM-YYYY') }}</td>
                <td>
                  <span style="padding:2px 8px; background:#eff6ff; color:#2563eb; border-radius:20px; font-size:11px; font-weight:600;">
                    {{ payment.payment_mode }}
                  </span>
                </td>
                <td>{{ payment.reference_number || '-' }}</td>
                <td>{{ payment.remarks || '-' }}</td>
                <td>{{ payment.created_by?.name || '-' }}</td>
                <!-- <td>
                  <button class="btn btn-sm btn-outline-danger" @click="deletePayment(payment.id)">
                    <i class="ti ti-trash"></i>
                  </button>
                </td> -->
              </tr>
              <tr v-if="!payments.length">
                <td colspan="7" class="text-center text-muted py-3">No payments recorded yet.</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div class="modal-footer" style="border-top:1px solid #e2e8f0; padding:12px 20px;">
        <button class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>
</template>